export const contactsData = {
    email: 'ayushmangal121212@gmail.com',
    phone: '9516086276',
    address: 'Bhopal, Madhya Pradesh',

    sheetAPI: ''
}